import { RouteObject } from 'react-router'

import { PLATFORM } from '@/constants/platform'
import { DDE_MENU_ICONS } from '@/router/icons'
import { DistributionListView } from '@/views/DistributionList/DistributionListView'

export const distributionListRoutes: RouteObject[] = [
  {
    label: 'Distribution List',
    path: 'distribution-list',
    icon: DDE_MENU_ICONS.DISTRIBUTION_LIST,
    element: <DistributionListView />,
    platforms: [PLATFORM.DDE]
  }
]
